import React from 'react';

import Dashboard from './Dashboard';
import DashboardCenter from '../dashboard/DashboardCenter';
import BlockMenu from './Kanban';
//
import About from './About';
//import Audit from './Audit';
import Inbox from './Inbox';
import Help from './Help';
import Main from './Main';
import Mapboard from './Mapboard';
import Memboard from './Memboard';
import SearchBoard from './Searchboard';
//import Privilege from './Privilege';
import Password from './Password';
import Profile from './Profile';
//import Role from './Role';
//import Searched from './Searched';
//import User from './User';
import Kanban from './Kanban';
//import ReportService from '../reports/oldReportService';
import Support from './Support';
import Testing from './Testing';
import TestPing from './Testping';
import Maintenance from './Maintenance';
// import Performance from '../ddash/Performance';
// import Rating from '../ddash/Rating';
// import Compliance from '../ddash/Compliance';
import Announcement from './Announcement';
// import Inspector from './Inspector';
// import Subscription from './Subscription';
import Requisition from './Requisition';
import Review from './Review';
import Approval from './Approval';
import Analysis from './Analysis';

// import Activity from './Activity';
import ActivityBudget from './ActivityBudget';
import ActivityMap from './ActivityMap';
import ActivityPlanning from './ActivityPlanning';
import ActivityProgramme from './ActivityProgramme';

import ObjectiveContract from './ObjectiveContract';
// import BudgetAllocation from './BudgetAllocation';
import ReportCenter from '../reports/ReportCenter';
// import Product from './Product';

// import BIECapacity from './BIECapacity';
// import BIEEntryWorkbench from './BIEEntryWorkbench';
// import BIEExecutive from './BIEExecutive';
// import BIEImport from './BIEImport';
// import BIESimulator from './BIESimulator';

import BudgetArbitration from './BudgetArbitration';
import BudgetConsolidation from './BudgetConsolidation';
import BudgetValidation from './BudgetValidation';
import DirectBudget from './DirectBudget';
import InvestmentBudget from './InvestmentBudget';

import PPMEngine from './PPMEngine';
import PPMProcess from './PPMProcess';
import PPMReport from './PPMReport';

import ApprovalRegister from './ApprovalRegister';
import ReviewRegister from './ReviewRegister';
import BudgetVersion from './BudgetVersioning';
import DeterminantBudget from './DeterminantBudget';
// import BIEForecast from './BIEForecast';
// import BIEForecastData from './BIEForecastData';
import ActivityMonitoring from './ActivityMonitoring';
import BIEForecasting from './BIEForecasting';
import BIEHistorical from './BIEHistorical';
import BIESimulation from './BIESimulation';
//import BIEDeterminant from './BIEDeterminant';
// import BIEReview from './BIEReview';
import PlanningCycle from './PlanningCycle';
import BIEOnboarding from './BIEOnboarding';
import Onboarding from './Onboarding';
import BIEOnboardingSession from './BIEOnboardingSession';
import BIEOnboardingWizard from './BIEOnboardingWizard';
import BIEOnboardingReview from './BIEOnboardingReview';
import BIEOnboardingImport from './BIEOnboardingImport';
import BIEOnboardingImportItem from './BIEOnboardingImportItem';
import BIEExecutiveReview from './BIEExecutiveReview';
import PlanningControl from './PlanningControl';
import BudgetControl from './BudgetControl';

//logout is handled in Home
const pages:any = {
  about: <About />, 
  help: <Help />,
  inbox: <Inbox />,
  announcement: <Announcement />,
  support: <Support />,

  menu: <BlockMenu />,
  kanban: <Kanban />,

  maintenance: <Maintenance/>,

  main: <Main />,
  
  dashboard: <DashboardCenter />,
  searchboard: <SearchBoard />,
  mapboard: <Mapboard />,
  memboard: <Memboard />,
  password: <Password />,
  profile: <Profile />,


  // Home
  //prerequisites: <BIEOnboardingSession />,
  onboarding: <Onboarding />, //institutionsetup

  bieonboarding: <BIEOnboardingSession />,
  bieonboardingsession: <BIEOnboardingSession />,
  bieonboardingwizard: <BIEOnboardingWizard />,
  bieonboardingreview: <BIEOnboardingReview />,
  bieonboardingimport: <BIEOnboardingImport />,
  bieonboardingimportitem: <BIEOnboardingImportItem />,

  planningcycle: <PlanningControl />,
  //planningcycle: <PlanningCycle />,
  
  biehistorical: <BIEHistorical />,
  bieforecasting: <BIEForecasting />,
  biesimulation: <BIESimulation />,
  bieexecutive: <BIEExecutiveReview />,

  determinantbudget: <DeterminantBudget />,

  budgetcontrol: <BudgetControl />,
  directbudget: <DirectBudget />,
  investmentbudget: <InvestmentBudget />,

  activityplanning: <ActivityPlanning />,
  activityprogramme: <ActivityProgramme />,
  activitybudget: <ActivityBudget />,

  budgetconsolidation: <BudgetConsolidation />,
  budgetarbitration: <BudgetArbitration />,
  budgetvalidation: <BudgetValidation />,
  budgetversion: <BudgetVersion />,

  ppmprocess: <PPMProcess />,
  ppmreport: <PPMReport />,
  //governanceregister: <ApprovalRegister />,
  governanceapproval: <ReviewRegister />,
  activitymonitor: <ActivityMonitoring />,
  taskmonitor: <ActivityMonitoring />,

  governanceregister: <BudgetControl />,

  // PLANNING CYCLE ROUTES
  //HISTORICAL_DATA: <BIEHistorical />,
  FORECAST_BASELINE: <BIEForecasting />,
  INTERACTIVE_SIMULATION: <BIESimulation />,
  //EXECUTIVE_REVIEW: <BIEExecutiveReview />,
  //DETERMINANT_BUDGET: <DeterminantBudget />,
  //BUDGET_CONTROL: <BudgetControl />,
  //ACTIVITY_PLANNING: <ActivityPlanning />,
  //ACTIVITY_PROGRAMME: <ActivityProgramme />,
  //BUDGET_ALLOCATION: <ActivityBudget />,
  //BUDGET_CONSOLIDATION: <BudgetConsolidation />,
  //BUDGET_VALIDATION: <BudgetValidation />,
  BUDGET_VERSIONING: <BudgetVersion />,
  //GOVERNANCE: <ApprovalRegister />,
  PPM: <PPMProcess />,
  //EXECUTION: <ActivityMonitoring />,
  //MONITORING: <ActivityMonitoring />,

  ONBOARDING: <BIEOnboardingSession />,
  PLANNING_CONTROL_CENTER: <PlanningControl />,
  HISTORICAL_DATA: <BIEHistorical />,
  FORECASTING: <BIEForecasting />,
  SIMULATION: <BIESimulation />,
  EXECUTIVE_REVIEW: <BIEExecutiveReview />,
  DETERMINANT_BUDGET: <DeterminantBudget />,
  BUDGET_CONTROL: <BudgetControl />,
  DIRECT_BUDGET: <DirectBudget />,
  INVESTMENT_BUDGET: <InvestmentBudget />,
  ACTIVITY_PLANNING: <ActivityPlanning />,
  ACTIVITY_PROGRAMME: <ActivityProgramme />,
  BUDGET_ALLOCATION: <ActivityBudget />,
  BUDGET_CONSOLIDATION: <BudgetConsolidation />,
  BUDGET_VALIDATION: <BudgetValidation />,
  PPM_PROCESSING: <PPMProcess />,
  PPM_REPORT: <PPMReport />,
  GOVERNANCE: <ApprovalRegister />,
  EXECUTION: <ActivityMonitoring />,
  MONITORING: <ActivityMonitoring />,


 


  // Workbenches
  // biesimulator: <BIESimulator />,
  // bieentrymanual: <BIEEntryWorkbench />,
  // bieentryimport: <BIEImport />,
  // bieexecutive: <BIEExecutive />,
  // biecapacity: <BIECapacity />,
  // bieforecast: <BIEForecast />,
  // bieforecastdata: <BIEForecastData />,
  
  objectivecontract: <ObjectiveContract />,
  activityaccount: <ActivityMap />,
  ppmengine: <PPMEngine />,
  approvalregister: <ApprovalRegister />,
  reviewregister: <ReviewRegister />,

  requisition: <Requisition />,
  formsreview: <Review />,
  formsapproval: <Approval />,
  formsanalytics: <Analysis />,

  reports: <ReportCenter />,
  budgetreport: <ReportCenter />,

  testapi: <Testing />,
  testping: <TestPing />,

};

export default pages;
